import { FreeReducedMealAppIncome } from './free-reduced-meal-app-income.model';

export class FreeReducedMealAppPerson {
    static frmaPersonIncrementor = -1;
    ID: number;
    AppID: number;
    PeopleID: number;
    FirstName: string;
    MiddleName: string;
    LastName: string;
    SuffixID: number;
    IsStudent: boolean;
    Income: FreeReducedMealAppIncome[] = [];

    // client properties
    isSelected: boolean;
    TotalIncome: number;
    TotalIncomeFrequency: string;
    TotalAnnualIncome: number;
    TotalIncomeHours: number;
    TotalIncomePer: string;
    UseAnnual = false;
    IsEnrolled = true;

    constructor() {
        this.ID = FreeReducedMealAppPerson.frmaPersonIncrementor--;
    }
}